import axios from "axios";
import { store } from "../app/store";
import { decryptText, encryptText } from "../utils/encryptionUtils";
import { getTokenExpirationDate } from "../utils/tokenInfo";

axios.defaults.headers.common['Content-Security-Policy'] = 'your-csp-value';
axios.defaults.headers.common['X-Content-Type-Options'] = 'nosniff';
axios.defaults.headers.common['X-Frame-Options'] = 'deny';
axios.defaults.headers.common['Strict-Transport-Security'] = 'max-age=31536000; includeSubDomains';
axios.defaults.headers.common['Cache-Control'] = 'no-cache';
axios.defaults.headers.common['Pragma'] = 'no-cache';

export async function getApi(url: string) {
    const request = getHeaders(false);
    return await axios.get(url, request)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.log(
                "error api get...................................................",
                error
            );
            return { statusCode: 401 };
        });
}

export async function getApiBlob(url: string) {
    const headers: any = getHeaders(true);
    return await axios.get(url, { responseType: 'blob', headers: headers })
        .then(response => {
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            return blob;
        })
        .catch(error => {
            console.log(
                "error api get...................................................",
                error
            );
            return { statusCode: 401 };
        });
}

export async function postApiBlob(url: string, data: any) {
    try {
        const request = getHeaders(false);
        const json = JSON.stringify(data);

        const response = await axios.post(url, json, {
            ...request,
            responseType: 'blob'
        });

        const blob = new Blob([response.data], { type: response.headers['content-type'] });

        return blob;
    } catch (error) {
        console.log(
            "error api post...................................................",
            error
        );
        return { statusCode: 401 };
    }
}

export async function postApi(url: string, data: any) {
    const request = getHeaders(false);
    const json = JSON.stringify(data);
    return await axios.post(url, json, request)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.log(
                "error api get...................................................",
                error
            );
            return { statusCode: 401 };
        });
}


export async function postImageApi(url: string, data: FormData) {
    return await axios.post(url, data, {
        "headers": {
            "Content-Type": "multipart/form-data",
            'Authorization': "Bearer " + decryptText(String(localStorage.getItem('token'))),
        }
    })
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.log(
                "error api get...................................................",
                error
            );
            return { statusCode: 401 };
        });
}

export async function putApi(url: string, data: any) {
    const request = getHeaders(false);
    const json = JSON.stringify(data);
    return await axios.put(url, json, request)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.log(
                "error api get...................................................",
                error
            );
            return { statusCode: 401 };
        });
}

export async function patchApi(url: string, data: any) {
    const request = getHeaders(false);
    const json = JSON.stringify(data);
    return await axios.patch(url, json, request)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.log(
                "error api patch...................................................",
                error
            );
            return { statusCode: 401 };
        });
}

export async function deleteApi(url: string) {
    const request = getHeaders(false);
    return await axios.delete(url, request)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.log(
                "error api get...................................................",
                error
            );
            return { statusCode: 401 };
        });
}

const getHeaders = (isImage: boolean) => {
    const state: any = store.getState();
    const token = decryptText(String(localStorage.getItem('token')));
    const expirationDate = getTokenExpirationDate(token);
    const currentDate = new Date();
    //if the current token has between 0 and 2 minutes to expired, 
    //we can use the same token in the request while another token is created
    if (isExpiredToken(expirationDate, currentDate)) {
        const tokenOfRefresh = decryptText(state.user.user.refreshToken);
        const expirationDateTokenRefresh = getTokenExpirationDate(tokenOfRefresh);
        validateExpiredTokenRefresh(expirationDateTokenRefresh, currentDate)
        refreshToken(tokenOfRefresh);
    }
    if (isImage)
        return { 'Authorization': "Bearer " + token }
    else {
        return {
            headers: {
                'Content-Type': "application/json; charset=UTF-8",
                'Authorization': "Bearer " + token,
            }
        };
    }
}

const isExpiredToken = (tokenDate: Date | null, currentDate: Date) => {
    if (tokenDate) {
        const differenceInMilliseconds = tokenDate.getTime() - currentDate.getTime();
        const differenceInMinutes = Math.floor(differenceInMilliseconds / (1000 * 60));
        if (differenceInMinutes < 0) {
            closeSession();
        }
        return differenceInMinutes < 6;
    }
}

const validateExpiredTokenRefresh = (tokenData: Date | null, currentDate: Date) => {
    if (tokenData) {
        const differenceInMilliseconds = tokenData.getTime() - currentDate.getTime();
        const differenceInMinutes = Math.floor(differenceInMilliseconds / (1000 * 60));
        if (differenceInMinutes < 0) {
            closeSession();
        }
    }
}

const refreshToken = async (refreshToken: string) => {
    var header = { headers: { 'RefreshToken': refreshToken } };
    const user = await axios.post(process.env.REACT_APP_GENERAL_API + `Users/validateTokenWebApp`, '', header)
        .then(result => {

            return result.data;
        })
        .catch(() => {
            closeSession();
        });
    if (user) {
        localStorage.removeItem('token');
        const newToken = encryptText(user.token);
        localStorage.setItem('token', newToken);
    }
}

const closeSession = () => {
    let urlAuthProvide = String(process.env.REACT_APP_AUTH_PROVIDER);
    let urlRedirect = String(process.env.REACT_APP_URL_REDIRECT);
    let url = `${urlAuthProvide}oauth/logout?post_logout_redirect_uri=${urlRedirect}`;
    document.location.href = url;
}
